module.exports = __webpack_public_path__ + "media/bb02-pw-entry.dedb52e1.mp4";